import React, { useEffect, useState } from 'react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show when scrolled down 500px, but hide if near the bottom (where pricing is)
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      // Hide if within 1500px of bottom to not overlap with pricing section
      const isNearBottom = documentHeight - (scrollY + windowHeight) < 1500;
      setIsVisible(scrollY > 500 && !isNearBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-40 bg-zinc-950/90 backdrop-blur-md border-t border-zinc-800 p-4 transform transition-transform duration-300 translate-y-0" data-id="element-80">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 max-w-4xl" data-id="element-81">
        <div className="hidden sm:block text-left" data-id="element-82">
          <p className="text-white font-bold" data-id="element-83">Código Asado: Sistema Maestro</p>
          <p className="text-amber-500 text-sm" data-id="element-84">
            11 Tomos + 4 Bonos Gratis Hoy
          </p>
        </div>
        <a href="#compra" className="w-full sm:w-auto bg-gradient-to-r from-amber-600 to-red-600 text-white font-bold py-3 px-8 rounded-full text-center shadow-[0_0_15px_rgba(245,158,11,0.3)] hover:shadow-[0_0_25px_rgba(245,158,11,0.5)] transition-all" data-id="element-85">
          SÍ, QUIERO EL SISTEMA →
        </a>
      </div>
    </div>;
}